import CreateSetupBackend from "../config/config.js";

let SetupBackend = null;

function create(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/pix/cashin/immediate/create", data);
}

function destroy(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.delete(
    `/v1/pix/cashin/immediate/destroy/${data.transactionid}`
  );
}

function update(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.put(
    `/v1/pix/cashin/immediate/update/${data.transactionid}`,
    data.body
  );
}

function bill(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(
    `/v1/pix/cashin/bill/create?email=${sessionStorage.getItem("emailUser")}`,
    data
  );
}

function index(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(`/v1/pix/cashin/immediate/index/${data.url}`);
}

function show(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/pix/cashin/show?limit=${100}&startDate=${data.startDate}&endDate=${
      data.endDate
    }&start=${data.start}&email=${sessionStorage.getItem("emailUser")}`
  );
}

function edit(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.patch(
    `/v1/pix/cashin/immediate/edit/${data.transactionid}`
  );
}

const backendServices = {
  create,
  destroy,
  update,
  index,
  show,
  edit,
  bill,
};

export default backendServices;
